import { styled } from '@mui/system'

export interface ProductsContainerProps {
  shrink?: boolean
}

export const ProductListContainer = styled('div')<ProductsContainerProps>(({ theme, shrink }) => ({
  ...(shrink ? { flexShrink: 2 } : { flexGrow: 1 }),
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px',
  minWidth: '350px',
  width: '100%',

  [theme.breakpoints.down('lg')]: {
    padding: '0',
    minWidth: 'unset',
  },
}))

export default ProductListContainer
